import React, { Dispatch, SetStateAction } from 'react'
import { FilterState } from '@pages/ApprovalRequests/RequestsList/Filter/type'
import { Status, SortOrder } from '@type/common'

interface DefaultProps {
  filters: FilterState
  sorting: Record<string, SortOrder>
  areFiltersCollapsed: boolean
  selectedRequestIds: { id: number; status: Status }[]
  setFilters: React.Dispatch<React.SetStateAction<FilterState>>
  setSorting: React.Dispatch<React.SetStateAction<Record<string, SortOrder>>>
  setSelectedRequestIds: Dispatch<SetStateAction<{ id: number; status: Status }[]>>
  setAreFiltersCollapsed: Dispatch<SetStateAction<boolean>>
}

export const Default: DefaultProps = {
  filters: {
    status: '',
    date: {},
    completionDate: {},
    workflow: '',
    actionRequired: false,
    requestor: '',
    approver: '',
    search: '',
    page: 1,
    limit: 1,
  },
  sorting: {},
  areFiltersCollapsed: false,
  selectedRequestIds: [],
  setFilters: () => null,
  setSorting: () => null,
  setSelectedRequestIds: () => null,
  setAreFiltersCollapsed: () => null,
}

export const Context = React.createContext(Default)

export default Context
